// @ts-strict-ignore
import Image from "next/image";
import styled from "styled-components";

export const SelectorContainer = styled.div`
  position: relative;
  margin-top: 24px;
  margin-bottom: 24px;
  ${({ theme: { media } }) => media.tablet`
    margin-top: 0;
    margin-bottom: 0;
  `}
`;

export const SelectedContainer = styled.span`
  align-items: center;
  display: inline-flex;
  cursor: pointer;
  img:first-child {
    width: 20px;
    height: 20px;
  }
`;

interface OptionsContainerProps {
  isVisible: boolean;
  center?: boolean;
}

export const OptionsContainer = styled.div<OptionsContainerProps>`
  ${({ isVisible }) => !isVisible && "display: none;"}
  ${({ center }) => (center ? "left: -50%;" : "left: -100%;")}
  border: 1px solid ${({ theme }) => theme.borderColors.primary};
  background: ${({ theme }) => theme.backgroundColors.primary};
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.08);
  position: absolute;
  border-radius: 10px;
  z-index: 2;
  bottom: 40px;
`;

export const Option = styled.span`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  width: 240px;
  height: 36px;
  padding: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.backgroundColors.secondary};
  }

  &:first-child {
    border-radius: 10px 10px 0 0;
  }

  &:last-child {
    border-radius: 0 0 10px 10px;
  }

  img {
    margin-right: -29px;
    margin-left: 11px;
  }
`;
